import * as React from 'react'
import { Button } from '../Button'
import { StyledAccordion, StyledAccordionBody, StyledAccordionHeader, StyledAccordionHeaderMain } from './styled'
import { AccordionProps } from './types'

export const Accordion = ({ headline, headerSub, children, theme, isOpen }: AccordionProps) => {
  const [isActive, setIsActive] = React.useState(isOpen)
  const bodyHeight = React.useRef(0)
  const accordionBody = React.useRef(null)

  React.useEffect(() => {
    const calculateHeight = () => {
      if (accordionBody) {
        accordionBody.current.style.height = 'auto'
        bodyHeight.current = accordionBody.current.offsetHeight
        accordionBody.current.style.height = ''
      }
    }

    calculateHeight()

    window.addEventListener('resize', calculateHeight)
    return () => {
      window.removeEventListener('resize', calculateHeight)
    }
  }, [])

  React.useEffect(() => {
    if (accordionBody.current) {
      const updateHeight = () => {
        requestAnimationFrame(() => {
          if (isActive) {
            accordionBody.current.style.height = bodyHeight.current + 'px'
          } else {
            accordionBody.current.style.height = '0px'
          }
        })
      }

      updateHeight()

      window.addEventListener('resize', updateHeight)
      return () => {
        window.removeEventListener('resize', updateHeight)
      }
    }
  }, [isActive])

  return (
    <StyledAccordion className={`theme-${theme}`}>
      <StyledAccordionHeader onClick={() => setIsActive(!isActive)}>
        <StyledAccordionHeaderMain>
          {headline}
          <Button
            $ignoreTheme
            $size="small"
            $variant="secondary"
            iconLeft={isActive ? 'minus' : 'plus'}
          />
        </StyledAccordionHeaderMain>
        {headerSub}
      </StyledAccordionHeader>
      <StyledAccordionBody ref={accordionBody}>{children}</StyledAccordionBody>
    </StyledAccordion>
  )
}
